import {Page} from "../../../../flair/Page.es6";
import {MapView} from "../../../../class/Map/MapView.es6";

Page.match("/app/va/directory/map").go(function() {
	let mapView = new MapView(document.querySelector("#map"));
});
